import { useEffect } from 'react';

export const useClickOutside = (
  ref: React.RefObject<HTMLElement | null>,
  callback?: () => void,
  excludeClassNames?: string[],
) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (!ref.current || ref.current.contains(event.target as Node) || !callback) return;

      if (!excludeClassNames || excludeClassNames.length === 0) return callback();

      let element = event.target as Element;

      while (element) {
        if (excludeClassNames.some((className) => element.classList?.contains(className))) return;

        element = element.parentElement as Element;
      }

      callback();
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, callback, excludeClassNames]);
};
